import { CSSProperties } from 'react'
import ReactVirtualList from 'react-virtual-list'
import InfiniteScroll from 'react-infinite-scroller'

type VirtualInfiniteListProps = {
  loadMore: () => void
  hasMore: boolean
  virtual: { style: CSSProperties; items: Array<unknown> }
}

const VirtualInfiniteList = (props: VirtualInfiniteListProps): JSX.Element => {
  const { loadMore, hasMore, virtual } = props
  return (
    <InfiniteScroll style={virtual.style} pageStart={0} loadMore={loadMore} hasMore={hasMore}>
      {virtual.items}
    </InfiniteScroll>
  )
}

export default ReactVirtualList()(VirtualInfiniteList)
